import { useMemo } from 'react';
import { useContentLocalizer } from '../hooks/useContentLocalizer';

/**
 * Breadcrumb localization strings for react-localization
 */
export const breadcrumbLocalization = {
  pt: {
    home: 'Início',
    knowledgeBase: 'Base de conhecimento',
    pipeline: 'Pipeline',
    documents: 'Documentos',
  },
  en: {
    home: 'Home',
    knowledgeBase: 'Knowledge Base',
    pipeline: 'Pipeline',
    documents: 'Documents',
  },
  es: {
    home: 'Inicio',
    knowledgeBase: 'Base de conocimiento',
    pipeline: 'Pipeline',
    documents: 'Documentos',
  },
};

/**
 * Hook to get localized breadcrumb labels
 * @returns Object with all localized breadcrumb labels for the current language
 */
export const useBreadcrumbLabels = () => {
  const localizer = useContentLocalizer(breadcrumbLocalization);

  // Memoize the result to prevent infinite re-renders
  return useMemo(
    () => ({
      home: localizer.home,
      knowledgeBase: localizer.knowledgeBase,
      pipeline: localizer.pipeline,
      documents: localizer.documents,
    }),
    [localizer.home, localizer.knowledgeBase, localizer.pipeline, localizer.documents],
  );
};
